import { Injectable } from '@angular/core';
import { ConstantService } from './constant.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor(
    private constantService: ConstantService,
) {}

decryptUsingAES256AndRFC2898(inputData : string) {
    // let keyWordArray = CryptoJS.enc.Utf8.parse(environment.activationEncryptionKey);
    // let keyAndIv = CryptoJS.PBKDF2(keyWordArray, this.SALT, {
    //   keySize: 256 / 32 + 128 / 32,
    //   iterations: this.ITERATIONS,
    //   hasher: CryptoJS.algo.SHA1
    // });
    // let hexKeyAndIv = CryptoJS.enc.Hex.stringify(keyAndIv);
    // let hexKey = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(0, 64));
    // let iv = CryptoJS.enc.Hex.parse(hexKeyAndIv.substring(64, hexKeyAndIv.length));
    const hexKey = CryptoJS.enc.Hex.parse('e262c271276d3fc387c2bd493b9270548c100000c4a09c5a73460fad13d17d89');
    const iv = CryptoJS.enc.Hex.parse('916b7ba5ed62b83188a8693c8f1db22f');

    const decrypted = CryptoJS.AES.decrypt(inputData, hexKey, {
        iv: iv
    });
    return decrypted.toString(CryptoJS.enc.Utf16LE);
}

encryptUsingAES256AndRFC2898(inputData: string) {
    try {
        const hexKey = CryptoJS.enc.Hex.parse('e262c271276d3fc387c2bd493b9270548c100000c4a09c5a73460fad13d17d89');
        const iv = CryptoJS.enc.Hex.parse('916b7ba5ed62b83188a8693c8f1db22f');
        return CryptoJS.AES.encrypt(CryptoJS.enc.Utf16LE.parse(inputData), hexKey, { iv: iv }).toString();
    } catch (error) {
        throw error;
    }
}

decryptUsingAES256(inputData: string) {
    const keyvalue = this.constantService.keyValue;
    // let keyvalue = Buffer.from([132, 42, 53, 124, 75, 56, 87, 38,
    //   9, 10, 161, 132, 183, 91, 105, 16,
    //   117, 218, 149, 230, 221, 212, 235, 64]).toString('hex');
    const ivValue = this.constantService.ivValue;
    // let ivValue = Buffer.from([83, 71, 26, 58, 54, 35, 22, 11,
    //   83, 71, 26, 58, 54, 35, 22, 11]).toString('hex');

    const _key = CryptoJS.enc.Hex.parse(keyvalue);
    const _iv = CryptoJS.enc.Hex.parse(ivValue);

    const decrypted = CryptoJS.AES.decrypt(inputData, _key, {
        iv: _iv
    });
    const encryptedOP = decrypted.toString(CryptoJS.enc.Utf8);
    return encryptedOP;
}
}
